import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import Exchange from '../../models/Exchange';
import User from '../../models/User';

export default class ExchangeBreadcrumb extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation),
        user: PropTypes.instanceOf(User).isRequired
    };

    getExchange() {
        return this.props.conversation.getExchange();
    }

    isHost() {
        return this.getExchange().get('host').id == this.props.user.id;
    }

    render() {
        return (
            <ol
                className={classNames('exchange-breadcrumb', {
                    mutual: this.props.conversation.isMutual()
                })}
            >
                {this.renderItems()}
            </ol>
        );
    }

    renderItems() {
        const exchangeAsGuest = this.props.conversation.getExchangeAsGuest();
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();

        const items = [];

        if (!this.props.conversation.getExchange()?.isFinishedOrCanceled()) {
            items.push([
                this.renderDetails(),
                <li className="spacer" key="spacer1"></li>,
                this.renderPreapprobation(),
                <li className="spacer" key="spacer2"></li>
            ]);

            items.push(this.renderFinalization());
        }

        if (items.length > 0) {
            return items;
        }

        // exchange for user has host is passed and has to managed deposit
        if (
            exchangeAsHost &&
            exchangeAsHost.isFinished() &&
            !exchangeAsHost.isCanceled() &&
            exchangeAsHost.hasDeposit()
        ) {
            items.push([this.renderDeposit()]);
        }

        // exchange has host is canceled and not free
        if (exchangeAsHost && exchangeAsHost.isCanceled() && !this.props.conversation.isFree()) {
            // exchange was canceled by user
            if (
                exchangeAsHost.has('user_annulation') &&
                exchangeAsHost.get('user_annulation').id !== this.props.user.id
            ) {
                if (items.length > 0) {
                    items.push([<li className="spacer" key="spacer2"></li>]);
                }
                items.push([this.renderGuestpoints()]);
            }
        }

        if (
            (exchangeAsGuest &&
                exchangeAsGuest.isFinishedOrCanceled() &&
                !exchangeAsGuest.isCanceledBy(this.props.user.id)) ||
            (exchangeAsHost &&
                exchangeAsHost.isFinishedOrCanceled() &&
                !exchangeAsHost.isCanceledBy(this.props.user.id))
        ) {
            if (items.length > 0) {
                items.push([<li className="spacer" key="spacer2"></li>]);
            }
            items.push([this.renderRating()]);
        }

        return items;
    }

    renderDetails() {
        return (
            <li
                key="details"
                className={classNames({
                    active: this.getExchange().get('status') >= Exchange.STATUS_DEFAULT,
                    done: this.getExchange().isFilled()
                })}
                title={i18n.t('exchange:breadcrumb_details')}
            >
                <span>{i18n.t('exchange:breadcrumb_details')}</span>
            </li>
        );
    }

    renderPreapprobation() {
        return (
            <li
                key="preapprobation"
                className={classNames({
                    active: this.getExchange().isFilled(),
                    done: this.getExchange().isApproved()
                })}
                title={i18n.t('exchange:breadcrumb_preapprobation')}
            >
                <span>{i18n.t('exchange:breadcrumb_preapprobation')}</span>
            </li>
        );
    }

    renderFinalization() {
        const { conversation } = this.props;
        return (
            <li
                key="finalization"
                className={classNames({
                    active: this.getExchange().isApproved(),
                    done: this.getExchange().isFinalized(),
                    finalized_by_guest:
                        conversation.isMutual() && conversation.getExchangeAsGuest()?.isFinalized(),
                    finalized_by_host:
                        conversation.isMutual() && conversation.getExchangeAsHost()?.isFinalized()
                })}
                title={i18n.t('exchange:breadcrumb_finalisation')}
            >
                <span>{i18n.t('exchange:breadcrumb_finalisation')}</span>
            </li>
        );
    }

    renderDeposit() {
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        return (
            <li
                key="deposit"
                className={classNames({
                    active: exchangeAsHost && exchangeAsHost.hasDeposit(),
                    done: exchangeAsHost && !exchangeAsHost.get('has_to_handle_deposit')
                })}
                title={i18n.t('exchange:breadcrumb_deposit')}
            >
                <span>{i18n.t('exchange:breadcrumb_deposit')}</span>
            </li>
        );
    }

    renderGuestpoints() {
        const exchangeAsHost = this.props.conversation.getExchangeAsHost();
        return (
            <li
                key="deposit"
                className={classNames({
                    active: !this.props.conversation.isFree(),
                    done: exchangeAsHost && !exchangeAsHost.get('has_to_handle_gp')
                })}
                title={i18n.t('exchange:breadcrumb_guestpoints')}
            >
                <span>{i18n.t('exchange:breadcrumb_guestpoints')}</span>
            </li>
        );
    }

    renderRating() {
        const { conversation } = this.props;
        const exchangeAsHost = conversation.getExchangeAsHost();
        const hasToHandleGP = exchangeAsHost && exchangeAsHost.get('has_to_handle_gp');
        return (
            <li
                key="rating"
                className={classNames({
                    active: !hasToHandleGP,
                    done: !hasToHandleGP && !conversation.hasOneOrMoreExchangeToBeRatedByUser()
                })}
                title={i18n.t('exchange:breadcrumb_rating')}
            >
                <span>{i18n.t('exchange:breadcrumb_rating')}</span>
            </li>
        );
    }
}
